import { getFieldRefs } from "@/stores/FieldRefsStore/FieldRefsStore.ts";
import { useCallback } from "react";

export const useRegisterFieldRef = (name: string) => {
  return useCallback(
    (el: HTMLElement | null) => {
      const refs = getFieldRefs();
      if (el) refs.set(name, el);
      else refs.delete(name);
    },
    [name],
  );
};
